/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Payment_Failed_Banner_TextInputs */



/**
* | output |
* | --- |
* | "⚠ Payment failed — all premium models are blocked. Update your payment method to restore access." |
*
* @param {Payment_Failed_Banner_TextInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const payment_failed_banner_text = /** @type {((inputs?: Payment_Failed_Banner_TextInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Payment_Failed_Banner_TextInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("⚠ Zahlung fehlgeschlagen — alle Premium-Modelle sind gesperrt. Aktualisieren Sie Ihre Zahlungsmethode, um den Zugang wiederherzustellen.")
	return /** @type {LocalizedString} */ ("⚠ Payment failed — all premium models are blocked. Update your payment method to restore access.")
});